import React from "react";
import { IconLock } from "../shared/Icons";

/**
 * Numbered step indicator across the top of the assessment form.
 * Props:
 *   sections       {string[]}  ordered list of section names for current type
 *   currentIdx     {number}
 *   reportIdx      {number}    index of the "Report" section
 *   reportUnlocked {boolean}
 *   onStepClick    {Function}  (idx) => void
 */
const StepperBar = ({ sections, currentIdx, reportIdx, reportUnlocked, onStepClick }) => (
  <div
    style={{
      // overflowX: "auto",
      padding: "16px 2px 4px",
      margin: "0 auto",
      width: "95%",
      display: "flex",
      alignItems: "flex-start",
    }}
  >
    {sections.map((section, i) => {
      const isReport = i === reportIdx;
      const locked   = isReport && !reportUnlocked;
      const isActive = i === currentIdx;
      const isPast   = i < currentIdx;

      return (
        <div
          key={section}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: "1",
            minWidth: "72px",
            cursor: locked ? "not-allowed" : "pointer",
            opacity: locked ? 0.55 : 1,
          }}
          onClick={() => onStepClick(i)}
          title={locked ? "Complete all sections before accessing Report" : section}
        >
          {/* Connector + circle */}
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            {/* Left connector — invisible for first item so circle stays centered */}
            <div style={{ flex: 1, height: "2px", background: i === 0 ? "transparent" : isPast ? "#bb1ccc" : "#ddd" }} />
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                background: locked ? "#aaa" : "#bb1ccc",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "13px",
                fontWeight: "bold",
                flexShrink: 0,
                opacity: !isActive && !isPast ? 0.4 : 1,
                // boxShadow: isActive ? "0 0 0 3px rgba(204,0,0,0.25)" : "none",
                transition: "box-shadow 0.2s",
              }}
            >
{locked ? (
  <IconLock />
) : isPast ? (
  "✔"
) : (
  i + 1
)}            </div>
            {/* Right connector — invisible for last item so circle stays centered */}
            <div style={{ flex: 1, height: "2px", background: i === sections.length - 1 ? "transparent" : isPast ? "#bb1ccc" : "#ddd" }} />
          </div>

          {/* Label */}
          <div
            style={{
              fontSize: "9px",
              color: isActive ? "#bb1ccc" : "#555",
              textAlign: "center",
              marginTop: "5px",
              lineHeight: 1.3,
              fontWeight: isActive ? "700" : "400",
            }}
          >
            {section}
          </div>
        </div>
      );
    })}
  </div>
);

export default StepperBar;